// react components
import React from 'react'
import {
    useSelector,
} from 'react-redux'

// data
import {
    contentTypeModelTypeSite,
    defaultReduxState,
} from 'data'

// pages
import {
    DetailFieldSet825,
    ListContent825,
} from 'pages'

// serializers
import {
    ContentTypeDetailPanelTypes,
    ContentTypeSettingsCustomTypes,
    ContentTypeSettingsTypes,
    MainIdNameSerializer,
} from 'serializers/site'

// props
type DetailContentBlock825Props = {
    contentType: contentTypeModelTypeSite
    contentTypeSettings: ContentTypeSettingsTypes
    contentTypeSettingsCustom: ContentTypeSettingsCustomTypes | undefined
    inModal?: boolean
    object: {
        id?: number
        active?: boolean
        get_image_hq?: string
        model_content_type_id?: number
        profile?: any
        sub_content_type?: MainIdNameSerializer
    }
    subContentTypeForced?: { id: number, name: string }
    tab: number
    tabData: ContentTypeDetailPanelTypes | undefined
}

// main
export const DetailContentBlock825: React.FC<DetailContentBlock825Props> = React.memo(({
    contentType,
    contentTypeSettings,
    contentTypeSettingsCustom,
    object,
    subContentTypeForced,
    tab,
    tabData,
}) => {

    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    if (tabData?.panelOptions?.hideIfNotStaff) return null
    if (tabData?.panelOptions?.hideIfNotSuperuser) return null

    const isJustInline = tabData?.blockList?.length! === 1 && tabData?.blockInline?.[tabData?.blockList?.[0]!]

    return (
        <div className={`dc-content${isJustInline ? ' dc-justinline' : ''} mo-hidden-vertical-scrollbar ${tab}`}>
            {object.active === false && <p className='dc-panel-inactive'>{reduxText[5616]}</p>}
            {tabData?.blockList?.map(val => {
                if (tabData.blockFieldSet?.[val]) {
                    return (
                        <DetailFieldSet825
                            key={val}
                            blockId={val}
                            contentType={contentType}
                            contentTypeSettings={contentTypeSettings}
                            contentTypeSettingsCustom={contentTypeSettingsCustom}
                            fieldSetObject={tabData.blockFieldSet[val]}
                            object={object}
                            subContentTypeForced={subContentTypeForced}
                        />
                    )
                }
                if (tabData?.blockInline?.[val]) {
                    const blockInlineObject = tabData.blockInline[val]
                    const title = blockInlineObject.title
                    let listApiUrl = `${blockInlineObject.contentType.split('_')[0]}/list/${blockInlineObject.contentType.split('_')[1]}/?${blockInlineObject.parentModelField}=${object.id}${blockInlineObject.parentModelFieldCT ? `&${blockInlineObject.parentModelFieldCT}=${object.model_content_type_id}` : ''}`
                    if (blockInlineObject.filterParams) {
                        listApiUrl += `${blockInlineObject.filterParams}`
                    }
                    if (blockInlineObject.subContentTypes) {
                        blockInlineObject.subContentTypes.map(subcontenttype => (
                            listApiUrl += `&sub_content_type=${subcontenttype.id}`
                        ))
                    } else if (blockInlineObject.subContentType && blockInlineObject.subContentType.id !== 223 && !blockInlineObject.disableSubContentTypeFilter) {
                        listApiUrl += `&sub_content_type=${blockInlineObject.subContentType.id}`
                    }
                    const columns = blockInlineObject!.subContentType?.fields
                    return (
                        <ListContent825
                            key={val}
                            actionSheet='ActionComponent'
                            blockId={val}
                            blockInlineObject={blockInlineObject}
                            columns={columns}
                            contentType={blockInlineObject.contentType}
                            contentTypeParent={contentType}
                            contentTypeSettingsCustom={contentTypeSettingsCustom}
                            defaultFields={undefined}
                            detailObject={object}
                            listApiUrl={listApiUrl}
                            parentObject={object}
                            profile={object.profile}
                            tab={tab}
                            title={title}
                        />
                    )
                }
                return <p key={val}>Error: Missing block</p>
            })}
        </div>
    )
})
